import { AnalysisResult } from '@/gen/controls/v1/analysis_result_pb'

import { controlStatusToLemaInsight } from '@/const/label'

import type { EventProperties } from '@/lib/analytics/events'
import { cn } from '@/lib/ui/style-helpers'

import { EvaluationEvidence } from '@/pages/control/risk-questionnaire-thread-card/evaluation-evidence'
import { lemaAiAccentVariants } from '@/pages/control/risk-questionnaire-thread-card/variants'

import { insightsVariants } from '@/components/shared/insights/variants'

type EvaluationVerdictProps = {
  evaluation: AnalysisResult
  isHighlighted: boolean
  readOnly: boolean
  trackingProps: EventProperties
}

export const EvaluationVerdict = ({
  evaluation,
  isHighlighted,
  readOnly,
  trackingProps,
}: EvaluationVerdictProps) => (
  <div
    className={cn(
      insightsVariants({ variant: isHighlighted ? 'default' : 'inactive' }),
      'flex flex-col gap-3',
    )}
  >
    <p className='text-main-foreground-primary text-body-default'>
      <span className={cn('mr-1 text-label-default', lemaAiAccentVariants({ isHighlighted }))}>
        {controlStatusToLemaInsight[evaluation.status]}:
      </span>
      <span>{evaluation.summary}</span>
    </p>
    <EvaluationEvidence
      quotes={evaluation.quotes}
      readOnly={readOnly}
      trackingProps={trackingProps}
    />
  </div>
)
